import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, CollapseCard, FlexBox, NavigationButton, } from '@dixa/lib-shared-habla';
import React, { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getChannelName } from 'app/utils/channelName';
import { analytics } from 'app/utils/segment';
import { createSearchUrl } from 'app/views/layout/views/search/utils';
import { getConversationTitle } from 'components/conversationsOverview/components/ConversationDetails/helpers';
import '../../../../styles/cards.less';
import { HistoryCardItem } from './historyCardItem/historyCardItem';
export const HistoryCard = memo(function HistoryCard({ isOpen, onToggle, previousConversations, requester, isMinimized = false, }) {
    const navigate = useNavigate();
    const renderTitle = useCallback(({ metaConversation }) => {
        const subject = getConversationTitle(metaConversation).subject;
        const channelName = metaConversation.conversation.initial_channel
            ? getChannelName(metaConversation.conversation.initial_channel)
            : null;
        return _jsx("span", { children: subject ? subject : channelName });
    }, []);
    const handleOnConversationLinkClick = useCallback(() => {
        analytics.conversationSidebarConversationHistoryNavigatedToConversation();
    }, []);
    const handleOnToggle = useCallback((isOpen) => {
        if (isOpen) {
            analytics.conversationSidebarConversationHistoryOpened();
        }
        else {
            analytics.conversationSidebarConversationHistoryClosed();
        }
        onToggle();
    }, [onToggle]);
    const avatar = _jsx(Avatar, { icon: "history" });
    if (isMinimized) {
        return _jsx("div", Object.assign({ className: "icon-holder" }, { children: avatar }));
    }
    let showAllConversationBtn = null;
    if (previousConversations.length > 3) {
        const { id } = requester;
        const searchUrlWithFilter = createSearchUrl('conversations', {
            filters: {
                strategy: 'all',
                conditions: [
                    {
                        field: 'requested_by',
                        operator: 'is_one',
                        values: [{ label: '', value: id }],
                    },
                ],
            },
        });
        showAllConversationBtn = (_jsx(NavigationButton, Object.assign({ className: "card-action-btn", navigate: () => navigate(searchUrlWithFilter) }, { children: "Show all conversations" })));
    }
    if (!previousConversations.length) {
        return null;
    }
    return (_jsxs(CollapseCard, Object.assign({ onToggle: handleOnToggle, isOpen: isOpen }, { children: [_jsx(CollapseCard.Header, Object.assign({ avatar: avatar }, { children: "Conversation history" })), _jsx(CollapseCard.Content, { children: previousConversations
                    .slice(0, 3)
                    .map(({ conversation }, index) => {
                    var _a;
                    return (_jsx(HistoryCardItem, { conversation: conversation, handleOnConversationLinkClick: handleOnConversationLinkClick, renderTitle: renderTitle }, (_a = conversation.id) !== null && _a !== void 0 ? _a : index));
                }) }), _jsx(CollapseCard.Content, { children: _jsx(FlexBox, Object.assign({ justifyContent: "center", alignItems: "center", padding: "200 0" }, { children: showAllConversationBtn })) })] })));
});
